import { PickingListReportWarehouse } from './picking-list-report-warehouse';
import { SalesOrderExtraReport } from './sales-order-extra-report';
import { SellingCompanyReport } from '../../../../tms-shared';

export interface PickingListReport {
  id: string;
  orderNo: number;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  dateOrdered: Date;
  dateOrderedString: string;
  enteredBy: string;
  customerAddress: string;
  customerAddressHTML: string;
  deliveryAddress: string;
  deliveryAddressHTML: string;
  deliveryTerms: string;
  modeOfTransport: string;
  shipper: string;
  shippingNotes: string;
  internalNotes: string;
  documentNotes: string;
  deliveryTermNotes: string;
  deliveryInstructions: string;
  deliveryAddressee: string;
  customerNotes: string;
  printDeliveryAddress: boolean;
  alreadyPrinted: boolean;
  datePrinted: string;
  printedBy: string
  duplicateDocument: string;

  sellingCompany: SellingCompanyReport;
  pickingListWarehouses: PickingListReportWarehouse[];
  salesOrderExtraItems: SalesOrderExtraReport[];
}
